module.exports = __webpack_public_path__ + "static/media/808Button--toggle.7ce35f7b.svg";